export default {
    getAllPushNotifications: () => {
        return {
            url: '/fhe/pushNotifications',
            method: 'GET'
        };
    },
    getPushNotificationDetails: pushNotificationId => {
        return {
            url: '/fhe/pushNotifications/:pushNotificationId',
            method: 'GET',
            route_params: {
                pushNotificationId
            }
        };
    },
    updatePushNotificationDetails: (form, pushNotificationId) => {
        let params = {};
        Object.keys(form).map(field => {
            if (form[field]) params[field] = form[field];
        });
        return {
            url: '/fhe/pushNotifications/:pushNotificationId',
            method: 'PATCH',
            route_params: {
                pushNotificationId
            },
            patch_params: params
        };
    },
    addPushNotification: form => {
        let params = {};
        Object.keys(form).map(field => {
            if (form[field]) params[field] = form[field];
        });
        return {
            url: '/fhe/pushNotifications/add',
            method: 'POST',
            post_params: params
        };
    }
};



// WEBPACK FOOTER //
// ./environments/fhe/data/PushNotifications/api.js